import { render, staticRenderFns } from "./BolusCalculatorSettingTable.vue?vue&type=template&id=f46394aa&scoped=true"
import script from "./BolusCalculatorSettingTable.vue?vue&type=script&lang=js"
export * from "./BolusCalculatorSettingTable.vue?vue&type=script&lang=js"
import style0 from "./BolusCalculatorSettingTable.vue?vue&type=style&index=0&id=f46394aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46394aa",
  null
  
)

export default component.exports